module.exports = __webpack_public_path__ + "img/USA_PROCESSED_MEATS.f89670fe.png";